export default __webpack_public_path__ + "static/media/ic_img_empty.9bf787f9.svg";